export const SENATE_ORG_ID = 64;
export const ASSEMBLY_ORG_ID = 65;
export const LEADERSHIP_ORG_IDS = [SENATE_ORG_ID, ASSEMBLY_ORG_ID];

export const LEADERSHIP_TITLES_BY_ORG = {
  [SENATE_ORG_ID]: [
    "President pro Tempore",
    "Majority Leader",
    "Assistant Majority Leader",
    "Democratic Caucus Chair",
    "Majority Whip",
    "Assistant Majority Whip",
    "Minority Leader",
  ],
  [ASSEMBLY_ORG_ID]: [
    "Speaker",
    "Speaker pro Tempore",
    "Assistant Speaker pro Tempore",
    "Majority Leader",
    "Assistant Majority Leader",
    "Assistant Majority Leader on Policy and Research",
    "Majority Whip",
    "Assistant Majority Whip",
    "Republican Leader",
    "Democratic Caucus Chair",
  ],
};
